import _moduleHelper from '@/store/modules/_moduleHelper';
import FileCategoriesService from '@/api/fileCategories.service';

export const NAMESPACE = 'FILE_CATEGORIES';

export const STATE = {
    FILE_CATEGORIES: 'FILE_CATEGORIES',
    PAGE: 'PAGE',
    ITEMS_PER_PAGE: 'ITEMS_PER_PAGE',
    TOTAL_ITEMS: 'TOTAL_ITEMS',
    SEARCH: 'SEARCH',
    ORDER_BY: 'ORDER_BY',
    ORDER: 'ORDER',
};

export const GETTERS = {};

export const MUTATIONS = {
    SET_FILE_CATEGORIES: 'SET_FILE_CATEGORIES',
    SET_PAGE: 'SET_PAGE',
    SET_ITEMS_PER_PAGE: 'SET_ITEMS_PER_PAGE',
    SET_TOTAL_ITEMS: 'SET_TOTAL_ITEMS',
    SET_SEARCH: 'SET_SEARCH',
    SET_ORDER_BY: 'SET_ORDER_BY',
    SET_ORDER: 'SET_ORDER',
};

export const ACTIONS = {
    GET_FILE_CATEGORIES: 'GET_FILE_CATEGORIES',
    POST_FILE_CATEGORY: 'POST_FILE_CATEGORY',
    PATCH_FILE_CATEGORY: 'PATCH_FILE_CATEGORY',
    DELETE_FILE_CATEGORY: 'DELETE_FILE_CATEGORY',
};

export const MODULE = {
    namespaced: true,
    state: {
        [STATE.FILE_CATEGORIES]: [],
        [STATE.PAGE]: 1,
        [STATE.ITEMS_PER_PAGE]: 10,
        [STATE.TOTAL_ITEMS]: null,
        [STATE.SEARCH]: '',
        [STATE.ORDER_BY]: 'sortIndex',
        [STATE.ORDER]: 'asc',
    },
    getters: {},
    mutations: {
        [MUTATIONS.SET_FILE_CATEGORIES]: (state, fileCategories) => state[STATE.FILE_CATEGORIES] = fileCategories,
        [MUTATIONS.SET_PAGE]: (state, page) => state[STATE.PAGE] = page,
        [MUTATIONS.SET_ITEMS_PER_PAGE]: (state, itemsPerPage) => state[STATE.ITEMS_PER_PAGE] = itemsPerPage,
        [MUTATIONS.SET_TOTAL_ITEMS]: (state, totalItems) => state[STATE.TOTAL_ITEMS] = totalItems,
        [MUTATIONS.SET_SEARCH]: (state, search) => state[STATE.SEARCH] = search,
        [MUTATIONS.SET_ORDER_BY]: (state, orderBy) => state[STATE.ORDER_BY] = orderBy,
        [MUTATIONS.SET_ORDER]: (state, order) => state[STATE.ORDER] = order,
    },
    actions: {
        async [ACTIONS.GET_FILE_CATEGORIES]({ state, commit }) {
            const { data } = await FileCategoriesService.getFileCategories(
                state[STATE.SEARCH],
                state[STATE.PAGE],
                state[STATE.ITEMS_PER_PAGE],
                state[STATE.ORDER_BY],
                state[STATE.ORDER],
            );
            commit(MUTATIONS.SET_FILE_CATEGORIES, data['hydra:member']);
            commit(MUTATIONS.SET_TOTAL_ITEMS, data['hydra:totalItems']);
        },
        async [ACTIONS.POST_FILE_CATEGORY]({ dispatch }, fileCategory) {
            const { data } = await FileCategoriesService.postFileCategory(fileCategory);
            await dispatch(ACTIONS.GET_FILE_CATEGORIES);

            return data;
        },
        async [ACTIONS.PATCH_FILE_CATEGORY]({ dispatch }, fileCategory) {
            const { data } = await FileCategoriesService.patchFileCategory(fileCategory);
            await dispatch(ACTIONS.GET_FILE_CATEGORIES);

            return data;
        },
        async [ACTIONS.DELETE_FILE_CATEGORY]({ dispatch }, fileCategory) {
            await FileCategoriesService.deleteFileCategory(fileCategory);
            await dispatch(ACTIONS.GET_FILE_CATEGORIES);
        },
    },
};

export default {
    NAMESPACE,
    STATE,
    GETTERS,
    MUTATIONS,
    ACTIONS,
    MODULE,
    ..._moduleHelper(NAMESPACE),
};
